module.exports = __webpack_public_path__ + "static/media/leverging_technology_for_earl_disease.9a620cc6.jpeg";